import React from 'react'
import { Chip } from '@mui/material'

type Props = {
    live: boolean
}

export default function ModeChip({ live }: Props) {
    return (
        <Chip
            size="small"
            label={live ? 'LIVE' : 'PAPER'}
            color={live ? 'error' : 'default'}
            variant={live ? 'filled' : 'outlined'}
            sx={{ height: 22, fontSize: '0.65rem', fontWeight: 700 }}
        />
    )
}
